interface Props {
  title: string
  description?: string
  actions?: React.ReactNode
}

export function PageHeading({ title, description, actions }: Props) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-stone-900 dark:text-stone-100">
          {title}
        </h1>
        {description ? (
          <p className="mt-1 text-sm text-stone-600 dark:text-stone-400">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex gap-2">{actions}</div> : null}
    </div>
  )
}
